import { Schema } from '@/components/schemaForm'
import api from '@services/api'
import { getAuthHeaders } from '@/utils/session'
interface ConfigList {
  [key: string]: Schema
}

const fillConfig: Schema = [
  {
    type: 'FormItem',
    props: {
      label: 'color',
      name: 'fill',
      valuePropName: 'color',
    },
    children: {
      type: 'ChromePicker',
    },
  },
]

const commonConfig: Schema = [
  {
    type: 'FormItem',
    props: {
      label: 'width',
      name: 'width',
    },
    children: {
      type: 'InputNumber',
      props: {
        placeholder: 'width',
        style: { width: '100%' },
      },
    },
  },
  {
    type: 'FormItem',
    props: {
      label: 'height',
      name: 'height',
    },
    children: {
      type: 'InputNumber',
      props: {
        placeholder: 'height',
        style: { width: '100%' },
      },
    },
  },
  {
    type: 'FormItem',
    props: {
      label: 'scaledWidth',
      name: 'scaledWidth',
    },
    children: {
      type: 'InputNumber',
      props: {
        placeholder: 'scaledWidth',
        style: { width: '100%' },
      },
    },
  },
  {
    type: 'FormItem',
    props: {
      label: 'scaledHeight',
      name: 'scaledHeight',
    },
    children: {
      type: 'InputNumber',
      props: {
        placeholder: 'scaledHeight',
        style: { width: '100%' },
      },
    },
  },
  {
    type: 'FormItem',
    props: {
      label: 'left',
      name: 'left',
    },
    children: {
      type: 'InputNumber',
      props: {
        placeholder: 'left',
        style: { width: '100%' },
      },
    },
  },
  {
    type: 'FormItem',
    props: {
      label: 'top',
      name: 'top',
    },
    children: {
      type: 'InputNumber',
      props: {
        placeholder: 'top',
        style: { width: '100%' },
      },
    },
  },
  {
    type: 'FormItem',
    props: {
      label: 'opacity',
      name: 'opacity',
    },
    children: {
      type: 'Slider',
      props: {
        max: 1,
        min: 0,
        step: 0.1,
      },
    },
  },
]

const configList: ConfigList = {
  image: [
    ...commonConfig,
    {
      type: 'FormItem',
      props: {
        label: 'src',
        name: 'src',
        valuePropName: 'fileList',
        getValueFromEvent(e: any) {
          if (Array.isArray(e)) {
            return e
          }
          return e && e.fileList
        },
      },
      children: {
        type: 'Upload',
        props: {
          maxCount: 1,
          listType: 'picture',
          accept: 'image/*',
          action: api.uploadImg,
          name: 'content',
          headers: getAuthHeaders() as Record<string, string>,
          data() {
            return {
              format: 'png',
              fulldim: '300x300',
              path: `${+new Date()}.png`,
            }
          },
        },
        children: {
          type: 'Button',
          props: {
            text: '更换图片',
            style: { width: '100%' },
          },
        },
      },
    },
  ],

  rect: [...commonConfig, ...fillConfig],

  ['i-text']: [
    ...commonConfig,
    ...fillConfig,
    {
      type: 'FormItem',
      props: {
        label: 'fontSize',
        name: 'fontSize',
      },
      children: {
        type: 'InputNumber',
        props: {
          style: { width: '100%' },
        },
      },
    },
    {
      type: 'FormItem',
      props: {
        label: 'fontWeight',
        name: 'fontWeight',
      },
      children: {
        type: 'Select',
        children: ['normal', 'bold', '400', '600', '800'].map(item => ({
          type: 'Option',
          props: {
            children: item,
            value: item,
            text: item,
          },
        })),
      },
    },
    {
      type: 'FormItem',
      props: {
        label: 'fontFamily',
        name: 'fontFamily',
      },
      children: {
        type: 'Select',
        children: ['OPPOSans-B', 'OPPOSans-H', 'OPPOSans-L', 'OPPOSans-M', 'OPPOSans-R'].map(
          item => ({
            type: 'Option',
            props: {
              children: item,
              value: item,
              text: item,
            },
          })
        ),
      },
    },
    {
      type: 'FormItem',
      props: {
        label: 'fontStyle',
        name: 'fontStyle',
      },
      children: {
        type: 'Select',
        children: ['normal', 'italic', 'oblique'].map(item => ({
          type: 'Option',
          props: {
            children: item,
            value: item,
            text: item,
          },
        })),
      },
    },
    {
      type: 'FormItem',
      props: {
        label: 'shadow',
        name: 'shadow',
      },
      children: {
        type: 'Input',
      },
    },
  ],
  default: [],
}

export default configList
